module.exports = __webpack_public_path__ + "img/reposicion-redes (1).37250bff.jpg";